import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import Modal from 'react-modal';
import '../stylesheets/components/forms.scss';
import '../stylesheets/components/modal.scss';
import '../stylesheets/components/wishes.scss';

class Wish extends Component{

	constructor(props) {
	    super(props);

	    this.state = {
	    	selectedItem: 'select',
	    	labelCity: 'Cidade',
	    	states: [],
	    	cities: [],
	    	modalIsOpen: false,
	    	message: ''
	    }

	    this.handleChange = this.handleChange.bind(this);
	    this.handleSubmit = this.handleSubmit.bind(this);
	    this.handleSuccess = this.handleSuccess.bind(this);
	    this.openModal = this.openModal.bind(this);
	    this.closeModal = this.closeModal.bind(this);
	}

	openModal() {
		this.setState({modalIsOpen: true});
	}

	closeModal() {
		this.setState({modalIsOpen: false});
	}

	handleChange(event){
		this.setState({ selectedItem: event.target.value });
		this.setState({ labelCity: 'Buscando cidades...' });

		fetch('http://portal-homologa4.serasaconsumidor.com.br/api/v1/states/' + event.target.value)
			.then(response => response.json())
			.then(data => { 
				this.setState({ cities: data });
			});
		this.setState({ labelCity: 'Selecione uma cidade.' });
	}

	handleSubmit(event){
		event.preventDefault();
    	const data = new FormData(event.target);

    	let requestPost = 'email=' + data.get('email') + 
    					  '&cpf=' + data.get('cpf') + 
    					  '&state_id=' + data.get('state') + 
    					  '&city_id=' + data.get('city');

    	fetch('http://portal-homologa4.serasaconsumidor.com.br/api/v1/wish', {
		  method: "POST",
		  headers: {
		    "Content-Type": "application/x-www-form-urlencoded"
		  },
		  body: requestPost
		})
		.then(response => response.json())
		.then((response) => {
			if(response.status === 200){
				this.setState({message: response.message});
				this.openModal();
			}
		});
	}

	componentDidMount(){
		fetch('http://portal-homologa4.serasaconsumidor.com.br/api/v1/states')
			.then(response => response.json())
			.then(data => { 
				this.setState({ states: data });
			});
	}

	handleSuccess(){
		return (
			<div>
		        <div className="o-row" >
		        	<div className="o-center" >
		        		<h2 className="c-title c-title--size-big c-title--family-roboto-light c-title--lineheight-2 c-title--color-purple o-margin--top-2 o-uppercase">
			          		Obrigado!
			          	</h2>
						<br />
						<br />
			        	<p className="c-title c-title--color-grey-1 c-title--weight-medium c-title--lineheight-2 c-title--align-justify o-margin--bottom-3">
			          	 	{ this.state.message }
			          	</p>
			    	</div>    
		        </div>

		        <div className="o-row" >
		        	<div className="o-center" >
		        		<br />
						<br />

	          	 		<button onClick={this.closeModal} className="c-btn c-btn--width c-btn--width-large c-btn--color c-btn--color-purple c-btn--shadow-purple">Navegue no nosso site</button>
	          	 	</div>
		        </div>
		    </div>
		);
	}

	render(){

		const states = this.state.states.map((item) => {
					      return (
					      	<option value={item.id}>{item.abbrev}</option>
					      )
					    });

		const cities = this.state.cities.map((item) => {
					      return (
					      	<option value={item.id}>{item.name}</option>
					      )
					    });

		const section = this.handleSuccess();

		return (
			<section className="o-wish" id="wishes">
				<div className="o-container" >
					<h2 className="c-title c-title--size-big c-title--family-bold c-title--color-white c-title--align-left c-title--border c-title--border-bottom">
						Quer o caminhão da próxima edição na sua cidade?
					</h2>

					<div className="o-row" >

						<p className="c-title c-title--width-medium c-title--color-white c-title--lineheight-3" >
							Preencha abaixo seu CPF, e-mail e cidade para votar.
						</p>

					</div>

					<div className="o-row" >
						<form className="o-forms" onSubmit={this.handleSubmit} >

							<div className="o-row" >

								<select name="state" className="js-state" onChange={this.handleChange} value={this.state.selectedItem}>
									<option value="">UF</option>
									{ states }
						        </select>
							
								<select name="city" className="js-city">
									<option value="">{ this.state.labelCity }</option>
									{ cities }
						        </select>

								<InputMask 
									type="text" 
									id="cpf" 
									name="cpf"
									className="form-cpf js-gtm-input" 
									placeholder="Informe seu CPF:" 
									required
									mask="999.999.999-99" maskChar=" "
									/>
							
								<input 
									type="email" 
									name="email" 
									id="email" 
									className="form-email js-gtm-input" 
									placeholder="Informe seu E-mail:" 
									required />
								
							</div>

							<div className="o-row" >
								<div className="o-center" >
									<button type="submit" className="c-btn c-btn--width c-title--weight-medium c-btn--width-large c-btn--color c-btn--color-white" id="send" >Votar</button>
								</div>
							</div>
						</form>
					</div>

				</div>
				<hr />

				<Modal
			          isOpen={this.state.modalIsOpen}
			          onAfterOpen={this.afterOpenModal}
			          onRequestClose={this.closeModal}
			          contentLabel="Votação"
			        >

			        <div className="o-modal" >

			        	<button onClick={this.closeModal} className="o-modal--close">X</button>

				        { section }
						
					</div>
		        </Modal>

			</section>
		)
	}

}

export default Wish


// WEBPACK FOOTER //
// ./src/components/Wish.js